export default __webpack_public_path__ + "static/media/image2.efe87bf8.jpg";